import { render, staticRenderFns } from "./BackOfficeLayout.vue?vue&type=template&id=49247406&"
import script from "./BackOfficeLayout.vue?vue&type=script&lang=js&"
export * from "./BackOfficeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports